import React, { forwardRef, useState, useMemo, useEffect } from 'react';
import cx from 'classnames';
import { Option } from '../../Select/OptionsList/Option/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import { WithCustomScrollbar } from '../../../common/WithCustomScrollbar/index.js';
import { CurrencyTabs } from '../CurrencyTabs/index.js';
import { checkInitialActiveTabId } from './utils/tabs.js';
import styles from './index.module.scss.js';

const Options = forwardRef(
  ({
    focusedId,
    handleSelect,
    isActive,
    isMultiple,
    list,
    searchedList,
    listboxId,
    optionId,
    optionKind,
    placeholder,
    selectedIds,
    setFocusedId,
    vevet,
    theme,
    text,
    ...props
  }, forwardedRef) => {
    const [innerList, setInnerList] = useState([]);
    const tabs = useMemo(
      () => list.map(
        ({ id, name, groupIcon }) => ({
          id,
          name,
          icon: groupIcon
        })
      ),
      [list]
    );
    const [activeCategoryId, setActiveCategoryId] = useState(
      checkInitialActiveTabId({
        initList: list,
        selectedIDS: selectedIds
      })
    );
    const activeCategory = useMemo(() => {
      const selectedGroup = innerList.find(
        (item) => item.id === activeCategoryId
      );
      return selectedGroup;
    }, [activeCategoryId, innerList]);
    useEffect(() => {
      setInnerList(searchedList);
    }, [searchedList]);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ...props,
        className: cx(styles.box, "crypto-select__options", {
          [styles[theme || ""]]: !!theme
        }),
        ref: forwardedRef
      },
      /* @__PURE__ */ React.createElement("div", { className: cx(styles.switch, "select__switch") }, /* @__PURE__ */ React.createElement(
        CurrencyTabs,
        {
          theme,
          activeID: activeCategoryId,
          tabs,
          onChange: (id) => setActiveCategoryId(id)
        }
      )),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles.options, "select__options"),
          role: "listbox",
          id: listboxId,
          "aria-label": placeholder,
          "aria-multiselectable": isMultiple,
          tabIndex: -1
        },
        /* @__PURE__ */ React.createElement(WithCustomScrollbar, { className: styles.scrollbar, updateKey: 500 }, !activeCategory ? null : /* @__PURE__ */ React.createElement(
          "div",
          {
            className: cx(styles.options, "select__inner-options"),
            key: activeCategory.id
          },
          activeCategory.options.map((subOption) => /* @__PURE__ */ React.createElement(
            "div",
            {
              className: styles["options-wrapper"],
              key: subOption.id,
              tabIndex: 0,
              role: "option",
              id: `${optionId}-${subOption.id}`,
              "aria-selected": selectedIds.includes(subOption.id),
              onMouseEnter: () => !vevet.isMobile && isActive && setFocusedId(subOption.id),
              onKeyDown: (e) => {
                if (e.key !== "Enter") {
                  return;
                }
                if (!vevet.isMobile && isActive) {
                  setFocusedId(subOption.id);
                }
              },
              onClick: () => handleSelect(subOption.id)
            },
            /* @__PURE__ */ React.createElement(
              Option,
              {
                ...subOption,
                id: subOption.id,
                $kind: optionKind,
                $isFocused: subOption.id === focusedId,
                $isSelected: selectedIds.includes(subOption.id),
                $theme: theme,
                bet: subOption.bet,
                labelBet: text?.bet
              }
            )
          ))
        ), !searchedList.length && /* @__PURE__ */ React.createElement("div", { className: styles["no-results"] }, "No results for this query"))
      )
    );
  }
);
Options.displayName = "Options";

export { Options };
//# sourceMappingURL=index.js.map
